import type { RouteObject } from 'react-router';

import { GatewaysPage } from './Gateways';

/**
 * `/payment-gateways`. One `RouteObject`, so the file is `.route.tsx` singular.
 *
 * This is one of the two routes that additionally require `admin`, and the
 * console **does not pre-compute that outcome**: an `operator` who reaches it
 * meets `backend-finance`'s own `403` on the route's read, and the surface
 * renders its error band. A client-side guard decides navigation; it is never an
 * authorization claim, and the origin a call arrives from is never an
 * authorization input.
 */
export const gatewaysRoute: RouteObject = {
  path: 'payment-gateways',
  element: <GatewaysPage />,
};
